module.exports = "/wwwroot/img/kasisydan-hsy.jpg?ver=8abfc71c";